<template>
	<el-dialog class="abow_dialog" title="选择人员" :visible.sync="userVisible" width="40%" append-to-body :before-close="close">
		<div class="dialog-body">
			<div class="body-content">
				<span style="line-height: 30px">选择：</span>
				<div class="tree-only">
					<div class="search-box">
						<el-input class="search-input" prefix-icon="el-icon-search" size="medium" v-model="searchName" placeholder="输入姓名进行搜索" clearable @keyup.enter.native='selectTree'></el-input>
						<el-button class="search-button" type="primary"  @click="selectTree" >搜索</el-button>
					</div>
					<div class="item-list-div">
						<div style="line-height: 30px">
							<span v-for="(nav,index) in navList" :key="nav.id" style="cursor: pointer" :class="{'navColor':index !== navList.length-1}" @click="clickNav(nav,index)">
								{{ nav.name }}
								<i class="el-icon-arrow-right" v-if="index !==navList.length-1"></i>
							</span>
						</div>
						<el-checkbox v-model="allChecked" @change="allCheckedChange">全选</el-checkbox>
						<div class="item-list" v-if="!isSearch">
							<div class="item-row ponter" v-for="org in orgList" :key="org.id" style="flex: 1;" @click="getChilds(org)">
								<el-row style="flex: 1;line-height: 32px;">
									<i class="el-icon-folder" style="margin-right: 5px;color: #AEE4FA"></i>
									<span class="md-ellipsis" style="width: 160px;display: inline-block;line-height: 15px;vertical-align: middle">{{ org.name }}</span>
									<el-button type="text"><i class="el-icon-share"></i>下级</el-button>
								</el-row>
							</div>
							<!-- <el-checkbox-group v-model="orgAndUserListIds" @change="orgAndUserListChange" disabled>
								<div class="item-row" v-for="org in orgList" :key="org.id">
									<el-checkbox v-model="org.checked" style="flex: 1;line-height: 32px;" :label="org.id">
										<i class="el-icon-folder" style="margin-right: 5px;color: #AEE4FA"></i>
										<span class="md-ellipsis" style="width: 160px;display: inline-block;line-height: 13px;">{{ org.name }}</span>
									</el-checkbox>
									<el-button type="text" @click="getChilds(org)"><i class="el-icon-share"></i>下级</el-button>
								</div>
							</el-checkbox-group> -->
							<el-checkbox-group v-model="orgAndUserListIds" @change="orgAndUserListChange">
								<div class="item-row" v-for="user in userList" :key="user.id">
									<el-checkbox v-model="user.checked" :label="user.id" style="flex: 1">
										<span class="span-prefix">
											{{ user.realName.substring(user.realName.length - 2, user.realName.length) }}
										</span>
										<span class="md-ellipsis span-normal">{{ user.realName }}</span>
									</el-checkbox>
								</div>
							</el-checkbox-group>
						</div>
						<div class="item-list" v-if="isSearch">
							<el-checkbox-group v-model="orgAndUserListIds" @change="orgAndUserListChange">
								<div class="item-row" v-for="user in userList" :key="user.id">
									<el-checkbox v-model="user.checked" :label="user.id" style="flex: 1">
										<div style="display: flex">
											<span class="span-prefix">
												{{ user.realName.substring(user.realName.length - 2, user.realName.length) }}
											</span>
											<span class="span-wenzi">
												<span class="md-ellipsis span-normal">{{ user.realName }}</span>
												<span class="md-ellipsis span-normal" v-if="user.departmentName">{{ user.departmentName }}</span>
											</span>
										</div>
									</el-checkbox>
								</div>
							</el-checkbox-group>
							<div v-if="userList.length == 0" class="empty-tip">暂无数据</div>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 30px"></div>
			<div class="body-content">
				<span style="line-height: 30px">已选：</span>
				<div class="tree-only">
					<div class="item-list-div">
						<div class="item-list">
							<div class="item-row" v-for="item in orgAndUserList" :key="item.id">
								<div v-if="item.relationType === 1" style="flex: 1">
									<i class="el-icon-folder" style="margin-right: 5px;color: #AEE4FA"></i>
									<span class="md-ellipsis span-normal">{{ item.name }}</span>
								</div>
								<div v-if="item.relationType === 0" style="flex: 1">
									<span class="span-prefix">
										{{ item.realName.substring(item.realName.length - 2, item.realName.length) }}
									</span>
									<span class="md-ellipsis span-normal">{{ item.realName }}</span>
								</div>
								<div>
									<el-button type="danger" icon="el-icon-delete" circle size="mini" @click="delCheck(item)"></el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="close">取 消</el-button>
			<el-button type="primary" @click="submitUser">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			userVisible: {
				default: false
			},
			selectOu: {
				default: []
			}
		},
		data() {
			return {
				allChecked: false,
				compId: this.$store.state.comp.compId,
				departmentId: 0,
				searchName: '',
				navList: [{
					name: "通讯录",
					id: 0
				}],
				orgList: [],
				userList: [],
				isSearch: false,
				orgAndUserList: [],
				orgAndUserListIds: [],
			}
		},
		created() {
			this.getOrgData();
			this.getUsersList();
		},
		mounted() {
			this.orgAndUserList = this.selectOu;
			this.orgAndUserListIds = this.selectOu.map(s => s.id);
		},
		methods: {
			//全选
			allCheckedChange(val) {
				if (val) {
					this.userList.forEach(u => {
						let has = this.orgAndUserListIds.some(t => t === u.id);
						if (!has) {
							this.orgAndUserListIds.push(u.id)
							u.relationType = 0
							this.orgAndUserList.push(u)
						}
					})
					// this.orgList.forEach(o => {
					// 	let has = this.orgAndUserListIds.some(t => t === o.id);
					// 	if (!has) {
					// 		this.orgAndUserListIds.push(o.id)
					// 		o.relationType = 1
					// 		this.orgAndUserList.push(o)
					// 	}
					// })
				} else {
					this.orgAndUserListIds = this.orgAndUserListIds.filter(ou => {
						return !this.userList.some(u => u.id === ou)
					})
					// this.orgAndUserListIds = this.orgAndUserListIds.filter(ou => {
					// 	return !this.orgList.some(o => o.id === ou)
					// })
					this.orgAndUserListChange();
				}
			},
			delCheck(data) {
				this.orgAndUserList = this.orgAndUserList.filter(i => i.id !== data.id)
				this.orgAndUserListIds = this.orgAndUserListIds.filter(i => i !== data.id)
				this.checkedAll();
			},
			orgAndUserListChange() {
				let users = this.userList.filter(u => {
					let has = this.orgAndUserListIds.some(_u => _u === u.id);
					!has && (this.orgAndUserList = this.orgAndUserList.filter(ou => ou.id !== u.id))
					return has && u;
				})
				let orgs = this.orgList.filter(o => {
					let has = this.orgAndUserListIds.some(_o => _o === o.id);
					!has && (this.orgAndUserList = this.orgAndUserList.filter(ou => ou.id !== o.id))
					return has && o;
				})
				users.forEach(u => {
					let has = this.orgAndUserList.some(ou => ou.id === u.id)
					u.relationType = 0;
					!has && this.orgAndUserList.push(u)
				})
				orgs.forEach(o => {
					let has = this.orgAndUserList.some(ou => ou.id === o.id)
					o.relationType = 1;
					!has && this.orgAndUserList.push(o)
				})
				this.checkedAll();
			},
			//判断是否是全选
			checkedAll() {
				let hasOrg = this.orgList.every(o => {
					return this.orgAndUserListIds.some(ou => ou === o.id);
				})

				let hasUser = this.userList.length && this.userList.every(u => {
					return this.orgAndUserListIds.some(ou => ou === u.id);
				})
				if (hasUser) {
					this.allChecked = true
				} else {
					this.allChecked = false
				}
			},
			clickNav(nav, index) {
				this.departmentId = nav.id
				if (nav.id) {
					this.orgList = nav.childs && [...nav.childs]
				} else {
					this.getOrgData();
				}
				this.getUsersList();
				this.navList = this.navList.filter((n, ind) => {
					return ind <= index;
				})
			},
			clear(data) {
				this.isSearch = false
				this.departmentId = 0;
				this.getOrgData();
				this.getUsersList();
			},
			getChilds(org) {
				this.navList.push(org)
				this.departmentId = org.id
				this.getUsersList();
				this.orgList = [...org.childs]
			},
			selectTree() {
				this.departmentId = 0;
				this.navList = [{
					name: "通讯录",
					id: 0
				}];
				if (!this.searchName) {
					this.isSearch = false
					this.getOrgData();
				} else {
					this.orgList = [];
					this.isSearch = true
				}
				this.getUsersList();
			},
			getOrgData() {
				let url = `/Yunos/Department/DepartmentTree?compId=${this.compId}`;
				this.$axios.get(url).then((res) => {
					this.orgList = res;
					this.checkedAll();
				});
			},
			//获取用户列表
			getUsersList() {
				this.userList.length = 0;
				let url = `/Yunos/Employee/EmployeePageList?isInherit=false&compId=${this.compId}&pageIndex=1&pageSize=10000`;
				if (this.departmentId == 0 && this.searchName) {
					url += ('&realName=' + this.searchName);
				} else{
					url += ('&departmentId=' + this.departmentId + '&realName=' + this.searchName);
				}
				this.$axios.get(url).then(res => {
					this.userList = res.data;
					this.checkedAll();
				})
			},
			submitUser() {
				this.$emit("submitUser", this.orgAndUserList);
			},
			close(done) {
				this.$emit("close")
			}
		},
	}
</script>

<style scoped lang="scss">
	.empty-tip {
		color: #999999FF;
		text-align: center;
		margin-top: 40%;
	}
	.search-box{
				display: flex;
				border:1px solid #d9d9d9;
				border-radius:3px;
				width: 100%;
				::v-deep  .el-input--medium .el-input__icon {
					line-height: 32px;
				}
				.search-input{
					flex: 1;
					height: 32px;
					border-radius: 0;
					border-color: transparent;
					border-top-left-radius:3px;
					border-bottom-left-radius:3px;
					::v-deep input{
						height: 32px;
						line-height: 32px;
						font-size: 12px;
						border: none;
						border-radius: 0;
						border-color: transparent !important;
						border-top-left-radius:3px;
						border-bottom-left-radius:3px;
					}
				}
				.search-button{
					height: 32px;
					width: 62px;
					line-height: 0;
					background-color: #F6F7FBFF !important;
					color:#1890FFFF !important;
					border-color: transparent !important;
					margin-left: 0;
					border-radius: 0;
					font-size: 12px;
					border-top-right-radius:3px;
					border-bottom-right-radius:3px;
				}
			}
	.dialog-body {
		display: flex;
		height: 400px;

		.navColor {
			color: #38ADFE;
		}

		.body-content {
			flex: 1;
			display: flex;
			flex-direction: column;

			.tree-only {
				//background-color: #F4F6F8;
        background: white;
        border: 1px solid #d7d7d7;
        border-radius: 12px;
				flex: 1;
				padding: 15px;
				overflow: hidden;
				display: flex;
				flex-direction: column;

				.item-list-div {
					overflow: hidden;
					display: flex;
					flex-direction: column;

					.item-list {
						overflow: auto;

						.item-row {
							display: flex;
							margin: 4px 0;
							.span-normal {
								width: 160px;
								display: inline-block;
								line-height: 15px;
								vertical-align: middle;
							}

							.span-wenzi {
								display: inline-flex;
								flex-direction: column;

								span {
									font-size: 12px;
									line-height: 15px;
								}
							}

							.span-prefix {
								width: 30px;
								border-radius: 50%;
								background-color: #42b983;
								color: white;
								text-align: center;
								height: 30px;
								line-height: 30px;
								display: inline-block;
								font-size: 12px;
								margin-right: 5px;
								vertical-align: middle;
							}
						}
					}
				}
			}
		}
	}
</style>
